module.exports = __webpack_public_path__ + "media/images/allactive-0d80d4ba.png";